var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-xs-center" },
    [
      _c(
        "v-bottom-sheet",
        {
          attrs: { "hide-overlay": "", persistent: "" },
          model: {
            value: _vm.sheet,
            callback: function($$v) {
              _vm.sheet = $$v
            },
            expression: "sheet"
          }
        },
        [
          _c(
            "div",
            { staticClass: "content-holder" },
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", { staticClass: "sheet-title" }, [
                    _vm._v(_vm._s(_vm.$t("Error.Title")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sheet-content" }, [
                _vm.internalError && _vm.internalError.Reference
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Error.Reference")) +
                          " " +
                          _vm._s(_vm.internalError.Reference)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.internalError &&
                !_vm.internalError.Reference && _vm.internalError.Message
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Error.Message")) +
                          " " +
                          _vm._s(_vm.internalError.Message)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.internalError && _vm.internalError["content-server"]
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Error.Path")) +
                          " " +
                          _vm._s(_vm.internalError["content-server"])
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.internalError &&
                !_vm.internalError.Reference && _vm.userGUID
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Error.Device")) +
                          " " +
                          _vm._s(_vm.userGUID)
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.internalError &&
                _vm.datetime &&
                !_vm.internalError.Reference
                  ? _c("p", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Error.Date")) +
                          " " +
                          _vm._s(_vm.datetime) +
                          " [" +
                          _vm._s(_vm.timeZone) +
                          "]"
                      )
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fd817eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd817eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/errors/internalError.vue
// module id = null
// module chunks = 